__turbopack_context__.v({
  "className": "MvIQmG_className",
  "variable": "MvIQmG_variable",
});
